import { render, staticRenderFns } from "./ScrapTable.vue?vue&type=template&id=023ee0f0&scoped=true"
import script from "./ScrapTable.vue?vue&type=script&lang=js"
export * from "./ScrapTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ee0f0",
  null
  
)

export default component.exports